import { render, staticRenderFns } from "./LockerDetails.vue?vue&type=template&id=0588d4fc&scoped=true"
import script from "./LockerDetails.vue?vue&type=script&lang=js"
export * from "./LockerDetails.vue?vue&type=script&lang=js"
import style0 from "./LockerDetails.vue?vue&type=style&index=0&id=0588d4fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0588d4fc",
  null
  
)

export default component.exports